import { ListItemBox } from "lib/@components/ListItemBox"
import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function LocalAddition() {
    return (
        <ListItemBox sx={{ lineHeight: 0 }} spacing={1} direction="row" alignItems="center">
            <Box sx={{ color: "success.main" }}>
                <Iconify icon="mdi:add" Box />
            </Box>
            <Typography sx={{ color: "text.secondary" }} variant="caption">
                Only changed in your version
            </Typography>
        </ListItemBox>
    )
}
